import clsx from "clsx";
import { ShapeProps } from "./types";
import ClubIcon from "@mixitone/icons/shape-club.svg";

export const Club: React.FC<ShapeProps> = ({ color, size, className, style, children }) => {
  return (
    <div
      className={clsx("relative flex items-center justify-center", className)}
      aria-roledescription="color dot"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        ...style,
      }}
    >
      <ClubIcon className="absolute inset-0" width={size} height={size} style={{ fill: color }} />
      <span
        className="relative font-bold"
        style={{
          fontSize: `${size / 2}px`,
        }}
      >
        {children}
      </span>
    </div>
  );
};
